module.exports = __webpack_public_path__ + "static/media/coverImg-Taichi.0ffbbfab.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/Hashing/coverImg-Taichi.png
// module id = 175
// module chunks = 0